import STATES from './constants/state.constants';

function routesConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');

    const rootState = {
        name: 'root',
        url: '/'
    };

    const homeState = {
        name: 'home',
        url: '/home',
        views: {
            content: { template: '<home></home>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const manageSkillsState = {
        name: 'manageSkills',
        url: '/manage-skills',
        views: {
            content: { template: '<manageskills></manageskills>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const userState = {
        name: 'user',
        url: '/user',
        views: {
            content: { template: '<user></user>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const loginState = {
        name: 'login',
        url: '/login',
        template: '<login></login>'
    };

    const forgotPasswordState = {
        name: 'forgotPassword',
        url: '/forgot-password',
        template: '<forgot-password></forgot-password>'
    };

    const welcomeState = {
        name: 'welcome',
        url: '/welcome',
        template: '<welcome></welcome>'
    };

    const resetPasswordState = {
        name: 'resetPassword',
        url: '/reset-password',
        template: '<reset-password></reset-password>'
    };

    const evaluationState = {
        name: 'evaluation',
        url: '/evaluation',
        views: {
            content: { template: '<evaluation></evaluation>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const miniEvaluationState = {
        name: 'mini',
        url: '/mini',
        views: {
            content: { template: '<evaluation></evaluation>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const productsListState = {
        name: 'productsList',
        url: '/products-list',
        views: {
            content: { template: '<productslist></productslist>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const evaluationsListState = {
        name: 'evaluationsList',
        url: '/products-list/:productId',
        views: {
            content: { template: '<evaluationslist></evaluationslist>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const myEvaluationsListState = {
        name: 'myEvaluationList',
        url: '/my-evaluation-list',
        views: {
            content: { template: '<myevaluationlist></myevaluationlist>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const mySubEvaluationsListState = {
        name: 'mySubEvaluationList',
        url: '/my-evaluation-list/:productId',
        views: {
            content: { template: '<mysubevaluationslist></mysubevaluationslist>' },
            topbar: { template: '<topbar></topbar>' },
        },
    };

    const clientConfirmedState = {
        name: STATES.CLIENT_CONFIRMED,
        url: '/client/confirmed',
        template: '<client-confirmed></client-confirmed>'
    };

    const clientFormState = {
        name: STATES.CLIENT_FORM,
        url: '/client/:secret',
        template: '<clientform></clientform>'
    };

    const clientFormMiniState = {
        name: STATES.CLIENT_FORM_MINI,
        url: '/client/:type/:secret',
        template: '<clientform></clientform>'
    };

    $stateProvider.state(rootState);
    $stateProvider.state(homeState);
    $stateProvider.state(manageSkillsState);
    $stateProvider.state(userState);
    $stateProvider.state(loginState);
    $stateProvider.state(forgotPasswordState);
    $stateProvider.state(resetPasswordState);
    $stateProvider.state(welcomeState);
    $stateProvider.state(evaluationState);
    $stateProvider.state(myEvaluationsListState);
    $stateProvider.state(mySubEvaluationsListState);
    $stateProvider.state(miniEvaluationState);
    $stateProvider.state(productsListState);
    $stateProvider.state(evaluationsListState);
    $stateProvider.state(clientConfirmedState);
    $stateProvider.state(clientFormState);
    $stateProvider.state(clientFormMiniState);

    // use the HTML5 History API
    $locationProvider.html5Mode(true);
}

export default routesConfig;



// WEBPACK FOOTER //
// ./src/app/app.routes.js